module.exports = __webpack_public_path__ + "img/invalid_results.cd51093f.png";